import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'antd'
import { Icon } from '@iconify/react'

import { clearJobDetails, jobState, switchJobModal } from '../store/job.slice'
import AddEditJobForm from './AddEditJobForm'
import styles from './AddEditJob.module.css'

const AddEditJob = ({ from }) => {
    const dispatch = useDispatch()
    const { modalVariations } = useSelector(jobState)
    const isEdit = Boolean(modalVariations?.isEdit)
    const isSaving = Boolean(modalVariations?.saveButtonLoading)

    const handleCancel = () => {
        dispatch(
            switchJobModal({
                ...modalVariations,
                open: false,
                isEdit: false,
                selectedJobID: null,
                saveButtonLoading: false,
            })
        )

        if (from !== 'applicant') {
            dispatch(clearJobDetails())
        }
    }

    return (
        <Modal
            title={
                <div className={styles.modalHeader}>
                    <div className={styles.modalHeaderLeft}>
                        <div className={styles.modalHeaderIcon}>
                            <Icon
                                icon="mdi:briefcase-outline"
                                width={20}
                                height={20}
                            />
                        </div>
                        <div>
                            <div className={styles.modalHeaderTitle}>
                                {isEdit ? 'Edit Job' : 'Add Job'}
                            </div>
                            <div className={styles.modalHeaderSubtitle}>
                                {isEdit
                                    ? 'Update job details and hiring settings'
                                    : 'Create a new job posting'}
                            </div>
                        </div>
                    </div>
                </div>
            }
            open={Boolean(modalVariations?.open)}
            onCancel={handleCancel}
            footer={
                <div className={styles.modalFooter}>
                    <div className={styles.formActions}>
                        <button
                            type="button"
                            onClick={handleCancel}
                            disabled={isSaving}
                            className={styles.cancelButton}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            form="addEditJobAntdForm"
                            disabled={isSaving}
                            className={`${styles.submitButton} ${
                                isSaving ? styles.submitButtonDisabled : ''
                            }`}
                        >
                            {isSaving ? (
                                <>
                                    <Icon
                                        icon="line-md:loading-loop"
                                        width={16}
                                        height={16}
                                        className={styles.submitSpinner}
                                    />
                                    {isEdit ? 'Saving...' : 'Adding...'}
                                </>
                            ) : isEdit ? (
                                'Save'
                            ) : (
                                'Add Job'
                            )}
                        </button>
                    </div>
                </div>
            }
            width={820}
            className={styles.jobModal}
            destroyOnClose
            centered
            maskClosable={!isSaving}
            closable={!isSaving}
        >
            <div className={styles.modalBody}>
                <AddEditJobForm />
            </div>
        </Modal>
    )
}

export default AddEditJob
